import React, { useState, useRef, useEffect } from 'react';
// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { urlServidor } from '../../../helpers';
import { NetworkError } from "../../../_layout/genericComponents/Metodos";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar, handleAlertMutationGeneric, handleAlertGeneric } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';
import * as Consultas from './Consultas.js';
import * as ConsultasEmpresas from '../Empresas/Consultas.js';
import moment from 'moment';
import { seleccionRamoSeguro } from 'querys/RamoSeguro';
import { seleccionPolizasSeguro } from '../../../querys/PolizasSeguro';
import {getAllHistorialParidades} from '../../../querys/HistorialParidades';
import { seleccionDivisa } from 'querys/Divisa';
import * as Permisos from '../Permisos';

function IconoSimbolo({ simbolo = "" }) { return (<span>{simbolo}</span>); }
// Tiempo máximo que se espera a que termine el Excel de todo el folio
const MINUTOS_ESPERA_EXCEL = 15;
// Importes y porcentajes del presupuesto que no aceptan valores negativos
const CAMPOS_NO_NEGATIVOS = [
    ["sumaAseguradaPoliza", "La suma asegurada"],
    ["sumaAseguradaPresupuesto", "La suma asegurada presupuestada"],
    ["factorPrimaPromedio", "El factor prima promedio"],
    ["resultado", "El resultado"],
    ["porcentajeIncremento", "El % de incremento"],
    ["montoIncremento", "El monto de incremento"],
    ["primaNetaEstimada", "La prima neta estimada"],
    ["primaNetaPresupuesto", "La prima neta presupuestada"],
    ["tipoCambioPromedio", "El tipo de cambio promedio"],
    ["primaNetaPresupuestoMXN", "La prima presupuestada en MN"]
];

function PresupuestoAnual() {

    const { token, usuario } = useSelector(stDatos => stDatos.login);
    let anioActual = new Date().getFullYear();

    const cleanState = {};
    const cleanErrorState = {}
    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [stEmpresas, setEmpresas] = useState([]);
    // Seleccionables
    let [datosPDF, setdatosPDf] = useState({});
    const [seleccionables, setSeleccionables] = useState({});
    let [stDatos, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [ejercicios, setEjercicios] = useState([]);
    // La empresa inicial es la primera del catálogo; se asigna al cargar las empresas (ObtenerEmpresas)
    const [stateFiltros , setStateFiltros] = useState({
        empresaID: null,
        ejercicio: anioActual
    })
    const [stEmpresaDefault, setEmpresaDefault] = useState(null);
    // La tabla toma el valor inicial de sus filtros solo al montarse; se monta hasta tener la empresa inicial
    const [stEmpresasListas, setEmpresasListas] = useState(false);
    // Divisa inicial del formulario (MXN del catálogo de divisas)
    const [stDivisaDefault, setDivisaDefault] = useState("");
    const [stFolios, setFolios] = useState([]);

    let titleAccion = stDatos.presupuestoID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Presupuesto Anual`;
    let ArrayRef = [];
    const [filtros, setfiltros] = useState({ "ejercicio": anioActual, empresaID: null, folio:null });

    const [reporteExcel, setReporteExcel] = useState(null); // null - sin generar  1 - Generando  2 - Listo para descargar
    const [reporteFinalizado, setReporteFinalizado] = useState('');
    // Datos del Excel en proceso: folio, dirección del reporte anterior (para detectar el nuevo) y hora de inicio
    const refExcel = useRef({ empresaID: null, ejercicio: null, folio: null, anterior: '', inicio: 0 });

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "presupuestoID" }, { campo: "polizaID", variable: "polizaID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: Consultas.getPresupuestoAnual
        })
    },
    {
        accionID: [5],
        icono: PictureAsPdfIcon,
        color: primary,
        descripcion: "Generar PDF",
        parametros: [{ campo: "presupuestoID" }, { campo: "poliza" }],
        disabled: { multiseleccion: true },
        onClick: ({ presupuestoID, poliza }) => AuxDescargar(presupuestoID, poliza)
    },
    {
        accionID: [6],
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Generar Excel",
        parametros: [{ campo: "presupuestoID" }, { campo: "poliza" }],
        disabled: { multiseleccion: true },
        onClick: ({ presupuestoID, poliza }) => AuxDescargar(presupuestoID, poliza, 'excel')
    },
    {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "presupuestoID" },
        { campo: "poliza", variable: "poliza" },{ campo: "autorizado" }],
        disabled: { multiseleccion: true },
        onClick: ({ presupuestoID, poliza, autorizado }) => { 
            if (!autorizado) {
                handelAlertEliminar({
                    setAlert,
                    mensaje: ` el registro del presupuesto ${poliza}`,
                    onCancel: () => setAlert(null),
                    onConfirm: () => handleEliminar({
                        token, setAlert, setActualizar, actualizar,
                        parametros: { presupuestoID }, asyncDelete: Consultas.deletePresupuestoAnual
                    })
                });
            } else {
                setAlert({
                    descripcion: "No se puede eliminar presupuesto en proceso de autorización o autorizado",
                    title: "¡Una disculpa!",
                    tipo: "warning",
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null),
                    showCancel: false
                });    
            }
        },
    },
    {
        accionID: [8],
        icono: CheckCircleOutlineIcon,
        color: primary,
        descripcion: "solicitar preautorización",
        parametros: [{ campo: "presupuestoID" }, { campo: "poliza" }, { campo: "autorizado" }, { campo: "definitivo" }],
        disabled: { multiseleccion: true },
        onClick: ({ presupuestoID, poliza, autorizado, definitivo }) => ftAutorizarPresupuestoAnual(presupuestoID, poliza, autorizado, definitivo, token)
    }


];
    function AuxDescargar(presupuestoID, poliza, formatoReporte = 'PDF') {

        setdatosPDf({ "presupuestoID": presupuestoID, "poliza": poliza, formatoReporte });
        datosPDF = { "presupuestoID": presupuestoID, "poliza": poliza, formatoReporte };

        
        handleAlertGeneric({
            setAlert,
            onCancel: () => setAlert(null),
            mensaje: {
                title: "Generar Reporte", descripcion: "¿Deseas generar y descargar el formato de impresión del reporte de presupuesto actual?", tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
            },

            onConfirm: () => handleAlertMutationGeneric({
                token, setAlert, setActualizar, actualizar,
                parametros: {}, asyncMutation: () => DescargarPdf(),
                mensajes: {
                    msjEspera: {
                        title: "Espere...", descripcion: "Generando el formato de impresión del reporte de presupuesto actual ", tipo: success
                    },
                    msjCorrecto: {
                        title: "Se generó con éxito", descripcion: 'Se descargó el formato de impresión del reporte de presupuesto actual ' + poliza, msjConfirmacion: "Aceptar"
                    }
                }
            })
        })
    }

    const showFile = (archivo, name = 'file.pdf',) => {
        let url = window.URL.createObjectURL(archivo);
        let a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        a.remove();
    };

    const showURL = (url) => {
        let a = document.createElement('a');
        a.href = url;
        a.click();
        a.remove();
    };

    async function DescargarPdf() {
        
        let myHeaders = new Headers();
        myHeaders.append("token", token);
        myHeaders.append("mimeType", "multipart/form-data");

        let formdata = new FormData();
        formdata.append("presupuestoID", datosPDF.presupuestoID);
        formdata.append("formatoReporte", datosPDF.formatoReporte);

        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata
        };
        let nombreReporte = 'ReportePresupuestoAnual' + datosPDF.poliza
        await fetch(`${urlServidor}/service/reportes/ReportePresupuestoAnual`, requestOptions)
            .then(response => {
                if (!response.ok) return response.json();
                return response.blob()
            })
            .then(result => {
                let { error, mensaje } = result;
                if (error) throw new Error(mensaje);
                showFile(result, `${nombreReporte}${datosPDF.formatoReporte === 'PDF' ? '.pdf' : '.xlsx'}`); // mandar como variable dependiendo del if/case
                setAlert(null)
            })
            .catch(({ message }) => { throw new Error(message) });
    }

    let botones = [{
        accionID: [2],
        icono: Add,
        color: success,
        descripcion: "Agregar",
        onClick: () => Agregar(),
        disabled: { multiseleccion: true }
    }, {
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizar(!actualizar),
        disabled: { multiseleccion: true }
    }, {
        accionID: [9],
        icono: Add,
        color: success,
        descripcion: "Generar",
        onClick: () => GenerarPresupuestoAnual(),
        disabled: { multiseleccion: true }
    },{
        accionID: [6],
        icono: RiFileExcel2Fill,
        color: reporteExcel === 1 ? info : reporteExcel === 2 ? danger : success,
        descripcion: reporteExcel === 1 ? "Generando Excel" : reporteExcel === 2 ? "Obtener Excel Generado" : "Generar Excel",
        disabled: { multiseleccion: true },
        onClick: () => {
            // El estado pasa a "Generando" hasta que se confirma y se envía la solicitud (ver DescargarExcelTodos)
            if (reporteExcel === null) {
                GenerarExcelTodos();
            } else if (reporteExcel === 2) {
                showURL(reporteFinalizado);
                ftReiniciarExcel();
            }
        }
    },{
        accionID: [10],
        icono: DoneAllIcon,
        color: info,
        descripcion: "Autorizar Presupuesto",
        disabled: { multiseleccion: true },
        onClick: () => ftBloquearPresupuestoAnual()
    }];

    async function Agregar() {
        if (!filtros.empresaID || !filtros.ejercicio) {
            setAlert({
                descripcion: "Debe seleccionar la empresa y el ejercicio para agregar un registro",
                title: "¡Una disculpa!",
                tipo: "warning",
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
            return;
        }

        setState(stDatos => ({
            ...stDatos,
            ["empresaID"]: filtros.empresaID,
            ["ejercicio"]: filtros.ejercicio,
        }));

        let polizasSeguro = await seleccionPolizasSeguro({ filtro: { empresaID: filtros.empresaID , tipoPoliza:"PRINCIPAL"} }, token);

        setSeleccionables(seleccionables => ({
            ...seleccionables,
            polizasSeguro
        }));
        setOpen(true);

        let paridad = await ftUltimaParidad(stDatos.divisaID || stDivisaDefault);
        setState(stDatos => ({ ...stDatos, paridad }));
    }

    async function GenerarPresupuestoAnual() {
        if (!filtros.empresaID) {
            filtros.empresaID = -1;
        }
        if (!filtros.ejercicio) {
            filtros.ejercicio = -1;
        }

        filtros.empresaID = parseInt(filtros.empresaID);
        filtros.ejercicio = parseInt(filtros.ejercicio);

        try {
            if (filtros.empresaID === -1 || filtros.empresaID === null) throw new Error("Seleccionar empresa");
            if (filtros.ejercicio === -1 || filtros.ejercicio === null) throw new Error("Seleccionar ejercicio");
            setLoader(true);
            let Resultado = await Consultas.GenerarPresupuestoAnual(filtros, token);
            setLoader(false);
            setAlert({
                descripcion: Resultado,
                title: "Generar presupuesto",
                tipo: success,
                msjConfirmacion: "Aceptar",
                onConfirm: () => CerrarYActualizar()
            });
        } catch (error) {
            let descripcion = "Ocurrió un error al generar el presupuesto.";
            if (error.message) {
                descripcion = error.message;
            }

            setAlert({
                descripcion,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null)
            });
        }
    }


    async function GenerarExcelTodos() {
        if (!filtros.empresaID) {
            filtros.empresaID = -1;
        }
        if (!filtros.ejercicio) {
            filtros.ejercicio = -1;
        }

        filtros.empresaID = parseInt(filtros.empresaID);
        filtros.ejercicio = parseInt(filtros.ejercicio);

        setdatosPDf({ "empresaID":filtros.empresaID, "ejercicio":filtros.ejercicio,"presupuestoID": null, "poliza": filtros.ejercicio, "formatoReporte":'excel', folio: filtros.folio  });
        datosPDF = {"empresaID":filtros.empresaID, "ejercicio":filtros.ejercicio, "presupuestoID": null, "poliza": filtros.ejercicio, "formatoReporte":'excel', folio: filtros.folio };
        
        handleAlertGeneric({
            setAlert,
            onCancel: () => setAlert(null),
            mensaje: {
                title: "Generar Reporte", descripcion: "¿Deseas generar y descargar el formato de impresión del reporte de presupuesto actual?", tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
            },

            onConfirm: () => handleAlertMutationGeneric({
                token, setAlert, 
                setActualizar, actualizar,
                parametros: {}, 
                asyncMutation: () => DescargarExcelTodos(),
                mensajes: {
                    msjEspera: {
                        title: "Espere...", descripcion: "Generando el formato de impresión del reporte de presupuesto actual ", tipo: success
                    },
                    msjCorrecto: {
                        title: "Se envío con éxito la solicitud", descripcion: 'Se podra descargar en breve el formato de impresión del reporte de presupuesto actual ' + filtros.ejercicio, msjConfirmacion: "Aceptar"
                    }
                }
            })
        })
    }

    async function DescargarExcelTodos() {
        if (datosPDF.empresaID == null || datosPDF.empresaID === -1) throw new Error("Seleccionar empresa");
        if (datosPDF.folio == null) throw new Error("Seleccionar folio");
        if (datosPDF.ejercicio == -1 || datosPDF.ejercicio == null) throw new Error("Seleccionar ejercicio");

        let { empresaID, ejercicio, folio } = datosPDF;
        // Dirección del reporte que ya tenía el folio; el nuevo se reconoce porque es distinta
        let anterior = await ftDireccionReporte(empresaID, ejercicio, folio);
        refExcel.current = { empresaID, ejercicio, folio, anterior, inicio: Date.now() };

        let myHeaders = new Headers();
        myHeaders.append("token", token);
        myHeaders.append("mimeType", "multipart/form-data");

        let formdata = new FormData();
        formdata.append("presupuestoID", datosPDF.presupuestoID);
        formdata.append("formatoReporte", datosPDF.formatoReporte);
        formdata.append("empresaID", empresaID);
        formdata.append("ejercicio", ejercicio);
        formdata.append("folio", folio);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata
        };

        setReporteExcel(1);

        // No se espera: el reporte puede tardar más que el tiempo límite de la petición.
        // Si el servidor responde se revisa de inmediato; si responde con error se avisa y se reinicia.
        fetch(`${urlServidor}/service/reportes/ReportePresupuestoAnual`, requestOptions)
            .then(async response => {
                if (response.ok) return ftRevisarExcel(true);
                let { mensaje } = await response.json().catch(() => ({}));
                throw new Error(mensaje || "No se pudo generar el reporte");
            })
            .catch(({ message }) => {
                // Un corte de conexión o de tiempo no significa que falló: se sigue revisando
                if (/Failed to fetch|NetworkError|timeout/i.test(message)) return;
                ftReiniciarExcel();
                ftAlertaExcel(message);
            });
    }

    // Regresa la dirección del reporte guardada para el folio, o '' si no hay (o si la consulta falla)
    async function ftDireccionReporte(empresaID, ejercicio, folio) {
        let [registro] = await Consultas.seleccionFoliosPresupuestoReporte({ filtro: { empresaID, folio, ejercicio } }, token);
        // Cuando la consulta falla regresa el mensaje de error en label con value nulo
        if (!registro || registro.value === null || registro.value === undefined) return '';
        return registro.label || '';
    }

    // terminado: el servidor ya respondió, así que la dirección guardada es la del reporte nuevo aunque no haya cambiado
    async function ftRevisarExcel(terminado = false) {
        let { empresaID, ejercicio, folio, anterior, inicio } = refExcel.current;
        if (folio === null) return;

        let direccion = await ftDireccionReporte(empresaID, ejercicio, folio);
        if (direccion && (terminado || direccion !== anterior)) {
            setReporteFinalizado(direccion);
            setReporteExcel(2);
            setActualizar(actualizar => !actualizar);
            return;
        }

        if (Date.now() - inicio > MINUTOS_ESPERA_EXCEL * 60 * 1000) {
            ftReiniciarExcel();
            ftAlertaExcel(`El reporte no terminó de generarse después de ${MINUTOS_ESPERA_EXCEL} minutos, intenta de nuevo`);
        }
    }

    function ftReiniciarExcel() {
        refExcel.current = { empresaID: null, ejercicio: null, folio: null, anterior: '', inicio: 0 };
        setReporteExcel(null);
        setReporteFinalizado('');
    }

    function ftAlertaExcel(descripcion) {
        setAlert({
            descripcion,
            title: "¡Una disculpa!",
            tipo: danger,
            msjConfirmacion: "Aceptar",
            onConfirm: () => setAlert(null),
            showCancel: false
        });
    }

    function CerrarYActualizar() {
        setAlert(null);
        setActualizar(!actualizar);
    }

    const infoTabla = {
        botones,
        acciones,
        actualizar,
        id: "presupuestoID",
        color: primary,
        title: "Presupuesto Anual",
        iconTable: <FaRegMoneyBillAlt />,
        headers: [
            { variable: "presupuestoID", descripcion: "ID", hide: true },
            { variable: "polizaID", descripcion: "polizaID", hide: true },
            { variable: "folioInterno", descripcion: "Folio" },
            { variable: "ejercicioPresupuesto", descripcion: "Presupuesto" },
            { variable: "ejercicio", descripcion: "Ejercicio" },
            { variable: "empresa", descripcion: "Empresa" },
            { variable: "ramosseguro", descripcion: "Ramo de Seguro" },
            { variable: "poliza", descripcion: "No. Póliza" },
            { variable: "sumaAseguradaPoliza", descripcion: "Suma asegurada" },
            { variable: "sumaAseguradaPresupuesto", descripcion: "Suma asegurada presupuestada" },
            { variable: "factorPrimaPromedio", descripcion: "Factor prima promedio" },
            { variable: "vigenciaInicio", descripcion: "Inicio vigencia" },
            { variable: "vigenciaFinal", descripcion: "Termino de vigencia" },
            { variable: "resultado", descripcion: "Resultado" },
            { variable: "porcentajeIncremento", descripcion: "%Incremento" },
            { variable: "montoIncremento", descripcion: "Monto Incremento" },
            { variable: "primaNetaEstimada", descripcion: "Prima neta estimada" },
            { variable: "primaNetaPresupuesto", descripcion: "Prima neta presupuestada" },
            { variable: "divisa", descripcion: "Moneda" },
            { variable: "tipoCambioPromedio", descripcion: "Tipo de cambio promedio" },
            { variable: "primaNetaPresupuestoMXN", descripcion: "Prima presupuestada en MN" },
            { variable: "autorizado", descripcion: "Autorizado" },
            { variable: "fechaAutorizado", descripcion: "Fecha Autorizado" },
            { variable: "definitivo", descripcion: "Definitivo" },
            { variable: "fechaDefinicion", descripcion: "Fecha Definición" },
            { variable: "sumaAseguradaPolizaNueva", descripcion: "Suma Póliza Nueva" },
            { variable: "diferenciaSumasAseguradas", descripcion: "Diferencia Sumas Aseguradas" },
            { variable: "diferenciaPrimaNeta", descripcion: "Diferencia Prima Neta" },
            { variable: "fechaModificacion", descripcion: "Fecha Modificación" },
            { variable: "reporte", descripcion: "Reporte", hide: true }
        ],
        responsiveTitle: ["poliza"],
        alineacion: [{ columnas: [0, 1, 2, 3, 4, 5], alineacion: "left" },
        { columnas: [6, 7, 8, 11, 12, 13, 14, 15, 16], alineacion: "right" },
        { columnas: [9, 10], alineacion: "center" }],
        selectFilter: [
            {
                campo: "empresaID",
                title: "Empresa",
                retorna: "number",
                data: stEmpresas ? stEmpresas : [],
                grid: { md: 3, lg: 3 },
                funcionC: (valor, setSeleccionFiltro) => { setStateFiltros({ ...stateFiltros, empresaID: valor }); setfiltros(filtros => ({...filtros, folio: null})); setSeleccionFiltro(seleccionFiltro => ({ ...seleccionFiltro, folio: null })) },
                placeholder: "Seleccionar Empresa",
                defaultValue: stEmpresaDefault
            },
            {
                campo: "folio",
                title: "Folio",
                data:stFolios || [],
                grid: { md: 3, lg: 3 },
                placeholder: "Seleccionar folio",
                limpiarFiltro: "Todos los folios"
            },
            {
                campo: "ejercicio",
                title: "Ejercicio",
                retorna: "number",
                data: ejercicios,
                grid: { md: 3, lg: 3 },
                defaultValue: anioActual,
                funcionC: (data,setSeleccionFiltro) => {setStateFiltros({...stateFiltros, ejercicio: data}); setfiltros(filtros => ({...filtros, folio: null}));  setSeleccionFiltro(seleccionFiltro => ({ ...seleccionFiltro, folio: null })) },
            }],
        formato: [
            { columnas: ["sumaAseguradaPoliza", "sumaAseguradaPresupuesto", "resultado"], tipo: "moneda" },
            { columnas: ["factorPrimaPromedio"], tipo: "porcentaje" },
            { columnas: ["porcentajeIncremento"], tipo: "porcentaje" },
            { columnas: ["montoIncremento"], tipo: "moneda" },
            { columnas: ["primaNetaEstimada"], tipo: "moneda" },
            { columnas: ["primaNetaPresupuesto"], tipo: "moneda" },
            { columnas: ["tipoCambioPromedio"], tipo: "moneda" },
            { columnas: ["primaNetaPresupuestoMXN"], tipo: "moneda" },
            { columnas: ["vigenciaInicio","vigenciaFinal","fechaAutorizado","fechaModificacion","fechaDefinicion"], tipo: "fecha" , onlyDate: true},
            { columnas: ["autorizado"], tipo: "estatus" },
            { columnas: ["definitivo"], tipo: "estatus" },
            { columnas: ["sumaAseguradaPolizaNueva"], tipo: "moneda" },
            { columnas: ["diferenciaSumasAseguradas"], tipo: "moneda" },
            { columnas: ["diferenciaPrimaNeta"], tipo: "moneda" }
        ],
        handleFiltros: FiltrosActuales
    };

    

    function FiltrosActuales(id, value) {
        setfiltros(filtros => ({
            ...filtros,
            [id]: value
        }));
    }

    const inputs = [];
    const InputsConID = [];
    const Secciones = [];

    cleanErrorState["presupuestoID"] = { error: false, helperText: "" };
    cleanState["presupuestoID"] = 0;
    cleanState["empresaID"] = filtros.empresaID;
    cleanState["ejercicio"] = filtros.ejercicio;
    cleanState["ramosseguroID"] = 0;

    //----------------------------------------------------------------------------
    InicializarInputs("empresaID", "Empresa", "", filtros.empresaID);
    InicializarInputs("ejercicio", "Ejercicio", "", filtros.ejercicio);
    InicializarInputs("polizaID", "Póliza");
    InicializarInputs("ramosseguroID", "Ramo de Seguro", '', 0);
    InicializarInputs("vigenciaInicio", "Inicio vigencia", "", new Date(), "", 0, "center");
    InicializarInputs("vigenciaFinal", "Término de vigencia", "", new Date(), "", 0, "center");
    InicializarInputs("sumaAseguradaPoliza", "Suma asegurada", "", "0.00", "", 0, "right");
    InicializarInputs("sumaAseguradaPresupuesto", "Suma asegurada presupuestada", "", "0.00", "", 0, "right");
    InicializarInputs("factorPrimaPromedio", "Factor prima promedio", "", "0.00", "", 0, "right");
    InicializarInputs("resultado", "Resultado", "", "0.00", "", 0, "right");
    InicializarInputs("porcentajeIncremento", "%Incremento", "", "0.00", "", 0, "right");
    InicializarInputs("montoIncremento", "Monto Incremento", "", "0.00", "", 0, "right");
    InicializarInputs("primaNetaEstimada", "Prima neta estimada", "", "0.00", "", 0, "right");
    InicializarInputs("primaNetaPresupuesto", "Prima neta presupuestada", "", "0.00", "", 0, "right");
    InicializarInputs("divisaID", "Divisa","",stDivisaDefault);
    InicializarInputs("paridad", "Paridad", "", "", "", "", "", "right");
    InicializarInputs("tipoCambioPromedio", "Tipo de cambio promedio", "", "0.00", "", 0, "right");
    InicializarInputs("primaNetaPresupuestoMXN", "Prima neta presupustada conv. a MN", "", "0.00", "", 0, "right");

    //-----------------------------------------------------
    InputsConID["empresaID"].grid = { md: 4, lg: 4 };
    InputsConID["ejercicio"].grid = { md: 4, lg: 4 };
    InputsConID["ramosseguroID"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["polizaID"].grid = { md: 4, lg: 4 };
    InputsConID["divisaID"].grid = { md: 2, lg: 2 };
    InputsConID["paridad"].grid = { md: 2, lg: 2 };
    InputsConID["sumaAseguradaPoliza"].grid = { md: 3, lg: 3 };
    InputsConID["sumaAseguradaPresupuesto"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["factorPrimaPromedio"].grid = { md: 3, lg: 3 };
    InputsConID["vigenciaInicio"].grid = { md: 4, lg: 4 };
    InputsConID["vigenciaFinal"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["resultado"].grid = { md: 3, lg: 3 };
    InputsConID["porcentajeIncremento"].grid = { md: 3, lg: 3 };
    InputsConID["montoIncremento"].grid = { md: 3, lg: 3 };
    InputsConID["primaNetaEstimada"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["primaNetaPresupuesto"].grid = { md: 3, lg: 3 };
    InputsConID["tipoCambioPromedio"].grid = { md: 4, lg: 4 };
    InputsConID["primaNetaPresupuestoMXN"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------

    InputsConID["ejercicio"].disabled = true;
    InputsConID["empresaID"].disabled = true;
    InputsConID["empresaID"].tipo = "select";
    InputsConID["empresaID"].data = stEmpresas;

    InputsConID["ramosseguroID"].tipo = "select";
    InputsConID["ramosseguroID"].data = seleccionables.ramoSeguros;

    InputsConID["polizaID"].tipo = "select";
    InputsConID["polizaID"].data = seleccionables.polizasSeguro;
    InputsConID["polizaID"].disabled = stDatos.presupuestoID || !(stDatos.ramosseguroID !== 0 && stDatos.ramosseguroID !== '') ? true : false;

    InputsConID["divisaID"].tipo = "select";
    InputsConID["divisaID"].data = seleccionables.divisas;
    // Al modificar la SP no actualiza estos datos (vienen de la póliza); se bloquean para que no parezca que se cambian
    InputsConID["divisaID"].disabled = Boolean(stDatos.presupuestoID);
    InputsConID["paridad"].disabled = Boolean(stDatos.presupuestoID);
    InputsConID["ramosseguroID"].disabled = Boolean(stDatos.presupuestoID);
    InputsConID["sumaAseguradaPoliza"].disabled = Boolean(stDatos.presupuestoID);
    InputsConID["vigenciaInicio"].disabled = Boolean(stDatos.presupuestoID);
    InputsConID["vigenciaFinal"].disabled = Boolean(stDatos.presupuestoID);

    // Primer campo editable: al agregar el ramo (empresa y ejercicio vienen bloqueados); al modificar,
    // el primero que la SP sí guarda
    let refFocoFormulario = stDatos.presupuestoID ? ArrayRef["sumaAseguradaPresupuesto"] : ArrayRef["ramosseguroID"];

    InputsConID["vigenciaInicio"].tipo = "datetimepicker";
    InputsConID["vigenciaInicio"].timeFormat = false;
    InputsConID["vigenciaInicio"].onlyDate = true;
    InputsConID["vigenciaInicio"].onChange = (value) => { if (typeof value !== "object") return; handleChange(value, "vigenciaInicio"); };

    InputsConID["vigenciaFinal"].tipo = "datetimepicker";
    InputsConID["vigenciaFinal"].timeFormat = false;
    InputsConID["vigenciaFinal"].onlyDate = true;
    InputsConID["vigenciaFinal"].onChange = (value) => { if (typeof value !== "object") return; handleChange(value, "vigenciaFinal"); };

    InputsConID["sumaAseguradaPoliza"].textAlign = "right";
    InputsConID["sumaAseguradaPoliza"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["sumaAseguradaPoliza"].posicionIcono = "start";
    InputsConID["sumaAseguradaPoliza"].formatoImportes = true;
    InputsConID["sumaAseguradaPoliza"].onChange = ({ target: { value } }) => handleChange(value, "sumaAseguradaPoliza");

    InputsConID["sumaAseguradaPresupuesto"].textAlign = "right";
    InputsConID["sumaAseguradaPresupuesto"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["sumaAseguradaPresupuesto"].posicionIcono = "start";
    InputsConID["sumaAseguradaPresupuesto"].formatoImportes = true;
    InputsConID["sumaAseguradaPresupuesto"].onChange = ({ target: { value } }) => handleChange(value, "sumaAseguradaPresupuesto");

    InputsConID["factorPrimaPromedio"].textAlign = "right";
    InputsConID["factorPrimaPromedio"].icono = <IconoSimbolo simbolo="%" />;
    InputsConID["factorPrimaPromedio"].posicionIcono = "end";
    InputsConID["factorPrimaPromedio"].formatoImportes = true;
    InputsConID["factorPrimaPromedio"].onChange = ({ target: { value } }) => handleChange(value, "factorPrimaPromedio");

    InputsConID["resultado"].textAlign = "right";
    InputsConID["resultado"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["resultado"].posicionIcono = "start";
    InputsConID["resultado"].formatoImportes = true;
    InputsConID["resultado"].onChange = ({ target: { value } }) => handleChange(value, "resultado");

    InputsConID["porcentajeIncremento"].textAlign = "right";
    InputsConID["porcentajeIncremento"].icono = <IconoSimbolo simbolo="% " />;
    InputsConID["porcentajeIncremento"].posicionIcono = "end";
    InputsConID["porcentajeIncremento"].formatoImportes = true;
    InputsConID["porcentajeIncremento"].onChange = ({ target: { value } }) => handleChange(value, "porcentajeIncremento");

    InputsConID["montoIncremento"].textAlign = "right";
    InputsConID["montoIncremento"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["montoIncremento"].posicionIcono = "start";
    InputsConID["montoIncremento"].formatoImportes = true;
    InputsConID["montoIncremento"].onChange = ({ target: { value } }) => handleChange(value, "montoIncremento");

    InputsConID["primaNetaEstimada"].textAlign = "right";
    InputsConID["primaNetaEstimada"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["primaNetaEstimada"].posicionIcono = "start";
    InputsConID["primaNetaEstimada"].formatoImportes = true;
    InputsConID["primaNetaEstimada"].onChange = ({ target: { value } }) => handleChange(value, "primaNetaEstimada");

    InputsConID["primaNetaPresupuesto"].textAlign = "right";
    InputsConID["primaNetaPresupuesto"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["primaNetaPresupuesto"].posicionIcono = "start";
    InputsConID["primaNetaPresupuesto"].formatoImportes = true;
    InputsConID["primaNetaPresupuesto"].onChange = ({ target: { value } }) => handleChange(value, "primaNetaPresupuesto");

    InputsConID["tipoCambioPromedio"].textAlign = "right";
    InputsConID["tipoCambioPromedio"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["tipoCambioPromedio"].posicionIcono = "start";
    InputsConID["tipoCambioPromedio"].formatoImportes = true;
    InputsConID["tipoCambioPromedio"].onChange = ({ target: { value } }) => handleChange(value, "tipoCambioPromedio");

    InputsConID["primaNetaPresupuestoMXN"].textAlign = "right";
    InputsConID["primaNetaPresupuestoMXN"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["primaNetaPresupuestoMXN"].posicionIcono = "start";
    InputsConID["primaNetaPresupuestoMXN"].formatoImportes = true;
    InputsConID["primaNetaPresupuestoMXN"].onChange = ({ target: { value } }) => handleChange(value, "primaNetaPresupuestoMXN");

    
    function InicializarInputs(Identificador, pTitulo = "", pPlaceholder = "", ValorInicial = "", Seccion = "", MaxLength = 0, textAlign = 'left') {

        cleanErrorState[Identificador] = { error: false, helperText: "" };
        cleanState[Identificador] = ValorInicial;
        ArrayRef[Identificador] = useRef(null);

        if (pTitulo === "") {
            pTitulo = Identificador;
        }

        if (pPlaceholder === "") {
            pPlaceholder = pTitulo;
        }

        let tInput = {
            value: stDatos[Identificador],
            id: Identificador,
            error: errorState[Identificador].error,
            success: stDatos[Identificador] && !errorState[Identificador].error ? true : undefined,
            helperText: errorState[Identificador].helperText,
            inputRef: ArrayRef[Identificador],
            title: pTitulo,
            placeholder: pPlaceholder,
            textAlign: textAlign,
            onChange: ({ target: { value } }) => Identificador === "divisaID" ?  handleChangeDivisa(value) : handleChange(value, Identificador, MaxLength),
            onKeyDown: () => { return; }
        };

        InputsConID[Identificador] = tInput;
        if (Seccion === "") {
            inputs.push(tInput);
            return;
        }

        let tInputsDeSeccion = [];
        let InputFieldSet;
        if (Secciones[Seccion]) {
            InputFieldSet = Secciones[Seccion];
            tInputsDeSeccion = InputFieldSet.inputs;
        } else {
            InputFieldSet = {
                id: Seccion,
                leyenda: Seccion,
                placeholder: Seccion,
                tipo: "fieldset",
                sizeLetra: "1.05em"
            };

            inputs.push(InputFieldSet);
        }

        tInputsDeSeccion.push(tInput);
        InputFieldSet.inputs = tInputsDeSeccion;
        Secciones[Seccion] = InputFieldSet;
    }

    let accionesFormulario = [{
        accionID: stDatos["presupuestoID"] ? [3] : [2],
        loader,
        disabled: stDatos.autorizado ? true:false,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => { 
            handleGuardar({
                setLoader,
                setDisabled,
                setActualizar,
                actualizar,
                setNotificaciones,
                handleClose,
                handleFocus,
                refFocus: refFocoFormulario,
                mensajeCorrecto: `El registro del presupuesto se ${stDatos["presupuestoID"] ? "actualizó" : "agregó"} correctamente`,
                asyncCallback: ftGuardar,
            });
        },
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function ftBloquearPresupuestoAnual() {
        // Se autoriza todo el folio seleccionado en los filtros
        let datosAutorizar = { empresaID: filtros.empresaID, ejercicio: filtros.ejercicio, folio: filtros.folio };

        if (datosAutorizar.folio) {
            handleAlertGeneric({
                setAlert,
                onCancel: () => setAlert(null),
                mensaje: {
                    title: `Autorización Presupuesto Anual`, descripcion: `¿Deseas autorizar definitivamente el presupuesto anual?`, tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
                },

                onConfirm: () => handleAlertMutationGeneric({
                    token, setAlert, setActualizar, actualizar,
                    parametros: {}, asyncMutation: () => ftAutorizarDefinitivamente(datosAutorizar.empresaID, datosAutorizar.ejercicio, datosAutorizar.folio),
                    mensajes: {
                        msjEspera: {
                            title: "Espere...", descripcion: "Autorizando definitivamente el presupuesto anual.. ", tipo: success
                        },
                        msjCorrecto: {
                            title: `Se autorizó con éxito`, descripcion: `Se autorizó con éxito el presupuesto anual`, msjConfirmacion: "Aceptar"
                        }
                    }
                })
            })
        } else {
            setAlert({
                descripcion: "Favor de seleccionar un folio",
                title: "¡Una disculpa!",
                tipo: "warning",
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
        }
    }

    function ftAutorizarPresupuestoAnual(presupuestoID, poliza, autorizado, definitivo, token) {

        if (!definitivo) {

            let aux = autorizado ? "revertir la preautorización" : "preautorizar";
            let aux2 = autorizado ? "revirtió la preautorización" : "preautorizó";
            let aux3 = autorizado ? "Revertir preautorización" : "Preautorizar";
            
            handleAlertGeneric({
                setAlert,
                onCancel: () => setAlert(null),
                mensaje: {
                    title: `${aux3} Presupuesto Anual`, descripcion: `¿Deseas ${aux} el presupuesto anual?`, tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
                },

                onConfirm: () => handleAlertMutationGeneric({
                    token, setAlert, setActualizar, actualizar,
                    parametros: {presupuestoID,poliza}, asyncMutation: () => ftAutorizar(presupuestoID),
                    mensajes: {
                        msjEspera: {
                            title: "Espere...", descripcion: "Autorizando presupuesto anual.. ", tipo: success
                        },
                        msjCorrecto: {
                            title: `Se ${aux2} con éxito`, descripcion: `Se ${aux2} con éxito el presupuesto anual de la póliza ` + poliza, msjConfirmacion: "Aceptar"
                        }
                    }
                })
            })
        } else {
            setAlert({
                descripcion: "Póliza autorizada de forma definitiva, no se le podra efectuar cambio alguno.",
                title: "¡Una disculpa!",
                tipo: "warning",
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
        }
    }

    async function handleChangeDivisa(value) {
        setState(stDatos => ({ ...stDatos, divisaID: value }));
        let paridad = await ftUltimaParidad(value);
        setState(stDatos => ({ ...stDatos, paridad }));
        setErrorState(errorState => ({ ...errorState, paridad: { error: false, helperText: "" } }));
    }

    // Última paridad registrada de la divisa; vacía si no hay historial, para capturarla a mano
    async function ftUltimaParidad(divisaID) {
        let historial = await getAllHistorialParidades({ filtro: { divisaID } }, token).catch(() => []);
        return Array.isArray(historial) && historial[0] ? historial[0].paridad : "";
    }

    function ftAutorizar(presupuestoID) {
        async function ftAutorizar() {

            await Consultas.autorizarPresupuestoAnual({

                    presupuestoID: Number(presupuestoID)

            }, token) ;
            setActualizar(!actualizar);
        }
        return ftAutorizar();
    }

    function ftAutorizarDefinitivamente(empresaID, ejercicio, folio) {
        async function ftAutorizarDefinitivamente() {

            await Consultas.autorizarDefinitivamentePresupuestoAnual({

                    empresaID: Number(empresaID),
                    ejercicio: Number(ejercicio),
                    folio: Number(folio)

            }, token) ;
            setActualizar(!actualizar);
        }
        return ftAutorizarDefinitivamente();
    }

    function handleValidaciones() {
        let error;
        let validaciones = [
            {
                condicion: !stDatos["empresaID"] || stDatos["empresaID"] === 0,
                ref: ArrayRef["empresaID"], keyError: "empresaID",
                mensajeError: "Debe especificar la empresa"
            },
            {
                condicion: !stDatos["ejercicio"] || stDatos["ejercicio"] === 0,
                ref: ArrayRef["ejercicio"], keyError: "ejercicio",
                mensajeError: "Debe especificar el ejercicio"
            },
            {
                condicion: !stDatos["ramosseguroID"] || stDatos["ramosseguroID"] === 0,
                ref: ArrayRef["ramosseguroID"], keyError: "ramosseguroID",
                mensajeError: "Debe especificar el ramo de seguro"
            },
            {
                condicion: !stDatos["polizaID"] || stDatos["polizaID"] === 0,
                ref: ArrayRef["polizaID"], keyError: "polizaID",
                mensajeError: "Debe especificar la póliza"
            },
            {
                condicion: !stDatos["divisaID"] || stDatos["divisaID"] === 0,
                ref: ArrayRef["divisaID"], keyError: "divisaID",
                mensajeError: "Debe especificar la divisa"
            },
            {
                condicion: !(Number(stDatos["paridad"]) > 0),
                ref: ArrayRef["paridad"], keyError: "paridad",
                mensajeError: "Debe especificar la paridad"
            },
            {
                condicion: !stDatos["vigenciaInicio"] || !moment(stDatos["vigenciaInicio"]).isValid(),
                ref: null, keyError: "vigenciaInicio",
                mensajeError: "Debe especificar el inicio de vigencia"
            },
            {
                condicion: !stDatos["vigenciaFinal"] || !moment(stDatos["vigenciaFinal"]).isValid(),
                ref: null, keyError: "vigenciaFinal",
                mensajeError: "Debe especificar el término de vigencia"
            },
            {
                condicion: moment(stDatos["vigenciaFinal"]).isBefore(moment(stDatos["vigenciaInicio"]), 'day'),
                ref: null, keyError: "vigenciaFinal",
                mensajeError: "El término de vigencia no puede ser menor al inicio de vigencia"
            },
            ...CAMPOS_NO_NEGATIVOS.map(([campo, descripcion]) => ({
                condicion: Number(stDatos[campo]) < 0,
                ref: ArrayRef[campo], keyError: campo,
                mensajeError: `${descripcion} no puede ser negativo`
            }))
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {
            let error = await handleValidaciones();

            let DatosGuardar = { ...stDatos };

            DatosGuardar["empresaID"] = parseInt(DatosGuardar["empresaID"]);
            DatosGuardar["ejercicio"] = parseInt(DatosGuardar["ejercicio"]);
            DatosGuardar["ramosseguroID"] = parseInt(DatosGuardar["ramosseguroID"]);
            DatosGuardar["polizaID"] = parseInt(DatosGuardar["polizaID"]);
            DatosGuardar["divisaID"] = parseInt(DatosGuardar["divisaID"]);
            DatosGuardar["paridad"] = parseFloat(DatosGuardar["paridad"]);
            DatosGuardar["vigenciaInicio"] = formatearFecha(DatosGuardar["vigenciaInicio"]);
            DatosGuardar["vigenciaFinal"] = formatearFecha(DatosGuardar["vigenciaFinal"]);
            DatosGuardar["sumaAseguradaPoliza"] = parseFloat(DatosGuardar["sumaAseguradaPoliza"]);
            DatosGuardar["sumaAseguradaPresupuesto"] = parseFloat(DatosGuardar["sumaAseguradaPresupuesto"]);
            DatosGuardar["factorPrimaPromedio"] = parseFloat(DatosGuardar["factorPrimaPromedio"]);
            DatosGuardar["resultado"] = parseFloat(DatosGuardar["resultado"]);
            DatosGuardar["porcentajeIncremento"] = parseFloat(DatosGuardar["porcentajeIncremento"]);
            DatosGuardar["montoIncremento"] = parseFloat(DatosGuardar["montoIncremento"]);
            DatosGuardar["primaNetaEstimada"] = parseFloat(DatosGuardar["primaNetaEstimada"]);
            DatosGuardar["primaNetaPresupuesto"] = parseFloat(DatosGuardar["primaNetaPresupuesto"]);
            DatosGuardar["tipoCambioPromedio"] = parseFloat(DatosGuardar["tipoCambioPromedio"]);
            DatosGuardar["primaNetaPresupuestoMXN"] = parseFloat(DatosGuardar["primaNetaPresupuestoMXN"]);

            if (error) return error;

            delete DatosGuardar["empresa"];
            delete DatosGuardar["ramosseguro"];
            delete DatosGuardar["poliza"];
            delete DatosGuardar["divisa"];
            delete DatosGuardar["autorizado"];
            delete DatosGuardar["fechaAutorizado"];
            delete DatosGuardar["sumaAseguradaPolizaNueva"];
            delete DatosGuardar["diferenciaSumasAseguradas"];
            delete DatosGuardar["diferenciaPrimaNeta"];
            delete DatosGuardar["fechaModificacion"];
            delete DatosGuardar["folio"];
            delete DatosGuardar["definitivo"];
            delete DatosGuardar["fechaDefinicion"];
            
            if (stDatos["presupuestoID"]) {
                await Consultas.updatePresupuestoAnual(DatosGuardar, token);
            }
            else {
                delete DatosGuardar["presupuestoID"];
                await Consultas.addPresupuestoAnual(DatosGuardar, token);
            }
        }
        return ftGuardar();
    }

    function formatearFecha(pFecha) {
        if (moment(pFecha).isValid() === false) {
            return null;
        }

        let formatoFecha = "YYYY-MM-DD";
        return moment(pFecha).format(formatoFecha);
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key, MaxLength = 0) {
        if (value.length > MaxLength && MaxLength !== 0) {
            return;
        }

        if (key === "sumaAseguradaPoliza"
            || key === "factorPrimaPresupuesto"
            || key === "factorPrimaPromedio"
            || key === "resultado"
            || key === "porcentajeIncremento"
            || key === "montoIncremento"
            || key === "primaNetaEstimada"
            || key === "primaNetaPresupuesto"
            || key === "tipoCambioPromedio"
            || key === "primaNetaPresupuestoMXN") {
            if (value === "") {
                value = 0;
            }
            if (isNaN(Number(value))) {
                return;
            }
        }

        if(key === "ramosseguroID"){
            setState(stDatos => ({
                ...stDatos,
                [key]: value,
                polizaID: 0
            }));
            return;
        }

        setState(stDatos => ({
            ...stDatos,
            [key]: value
        }));

        setErrorState(errorState => ({
            ...errorState,
            [key]: { helperText: "", error: false }
        }));

        let recalcular = false;
        let tempDatos = {
            sumaAseguradaPoliza: stDatos["sumaAseguradaPoliza"],
            sumaAseguradaPresupuesto: stDatos["sumaAseguradaPresupuesto"],
            factorPrimaPromedio: stDatos["factorPrimaPromedio"],
            resultado: stDatos["resultado"],
            porcentajeIncremento: stDatos["porcentajeIncremento"],
            montoIncremento: stDatos["montoIncremento"],
            primaNetaEstimada: stDatos["primaNetaEstimada"],
            primaNetaPresupuesto: stDatos["primaNetaPresupuesto"],
            tipoCambioPromedio: stDatos["tipoCambioPromedio"],
            primaNetaPresupuestoMXN: stDatos["primaNetaPresupuestoMXN"]
        }

        // Se revisa que el campo exista y no su valor: con un 0 anterior el cálculo se quedaba con el valor viejo
        if (key in tempDatos) {
            tempDatos[key] = value;
        }

        if (key === "sumaAseguradaPoliza" || key === "sumaAseguradaPresupuesto" || key === "factorPrimaPromedio" || key === "porcentajeIncremento") {
            if (tempDatos.sumaAseguradaPresupuesto > 0) {
                tempDatos.resultado = Math.round(parseFloat(tempDatos.sumaAseguradaPresupuesto) * parseFloat(tempDatos.factorPrimaPromedio) * 100) / 100;
            }

            tempDatos.primaNetaEstimada = Math.round(parseFloat(tempDatos.resultado) * (1 + (parseFloat(tempDatos.porcentajeIncremento)/100)) * 100) / 100;
            tempDatos.montoIncremento = Math.round(parseFloat(tempDatos.resultado) * (parseFloat(tempDatos.porcentajeIncremento)/100) * 100) / 100;


            setState(stDatos => ({
                ...stDatos,
                ...tempDatos,
                [key]: value
            }));
        }

        if (key === "primaNetaPresupuesto" || key === "tipoCambioPromedio") {
            tempDatos.primaNetaPresupuestoMXN = Math.round(parseFloat(tempDatos.primaNetaPresupuesto) * parseFloat(tempDatos.tipoCambioPromedio) * 100) / 100;
            setState(stDatos => ({
                ...stDatos,
                ...tempDatos,
                [key]: value
            }));
        }
    }

    async function ObtenerEmpresas() {
        let Respuesta = await ConsultasEmpresas.seleccionEmpresa({}, token);
        setEmpresas(Respuesta);

        // Cuando la consulta falla regresa una sola opción con el error y value nulo
        let primera = (Array.isArray(Respuesta) ? Respuesta : []).find(({ value }) => value !== null && value !== undefined);
        if (primera) {
            let empresaID = Number(primera.value);
            // Solo la primera vez: esta función se vuelve a llamar al cambiar los filtros
            setEmpresaDefault(empresaDefault => empresaDefault === null ? empresaID : empresaDefault);
            setStateFiltros(stateFiltros => stateFiltros.empresaID ? stateFiltros : { ...stateFiltros, empresaID });
            setfiltros(filtros => filtros.empresaID ? filtros : { ...filtros, empresaID });
        }
        setEmpresasListas(true);
    }

  useEffect(() => {
        async function ftEffect() {
            if (!stateFiltros.empresaID) return;
            try {
                const folios = await Consultas.seleccionFoliosPresupuesto({filtro:{empresaID: stateFiltros.empresaID, ejercicio: stateFiltros.ejercicio}}, token);
                setFolios(folios);
            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null),
                    showCancel: false
                });
            }
        } ftEffect();
    }, [stateFiltros, actualizar]);
    

    

    useEffect(() => {
        async function ftEffect() {
            try {
                ObtenerEmpresas();
                let minEjercicio = await Consultas.getMinEjercicio(token);
                let ejerciciosTemp = [];
                let minAnio = parseInt(minEjercicio) - 3;
                let maxAnio = parseInt(anioActual) + 5;

                for (let i = minAnio; i <= maxAnio; i++) {
                    ejerciciosTemp.push({ value: i, label: i.toString() });
                }

                setEjercicios(ejerciciosTemp);

                let ramoSeguros = await seleccionRamoSeguro({ filtro: { fijo: true } }, token);
                // El catálogo manda el ID como texto y el presupuesto como número; se igualan para que el select lo encuentre
                // Solo las divisas marcadas como activas en el catálogo (FILTRAR), igual que en Paridades
                let divisas = (await seleccionDivisa({ filtro: { filtrar: true } }, token))
                    .map(divisa => ({ ...divisa, value: divisa.value === null || divisa.value === undefined ? divisa.value : Number(divisa.value) }));
                // La etiqueta del catálogo es "NOMBRE - (CÓDIGO)"; se propone MXN y si no existe la primera divisa
                let divisasValidas = divisas.filter(({ value }) => value !== null && value !== undefined);
                let mxn = divisasValidas.find(({ label }) => /\(MXN\)/.test(label || "")) || divisasValidas[0];
                if (mxn) {
                    setDivisaDefault(divisaDefault => divisaDefault === "" ? mxn.value : divisaDefault);
                    setState(stDatos => stDatos.presupuestoID || stDatos.divisaID ? stDatos : { ...stDatos, divisaID: mxn.value });
                }
                setSeleccionables(seleccionables => ({ ...seleccionables, ramoSeguros, divisas }));

            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null),
                    showCancel: false
                });
            }
        } ftEffect();
    }, [stateFiltros,actualizar]);

    useEffect(() => {
        async function ftActualizarListadoPolizas(){
            if(stDatos.ramosseguroID !== 0){
            let polizasSeguro = await seleccionPolizasSeguro({ filtro: { empresaID: filtros.empresaID, tipoPoliza:"PRINCIPAL", ramoSeguroID: stDatos.ramosseguroID} }, token);
            setSeleccionables({...seleccionables, polizasSeguro })
        }
        }
        ftActualizarListadoPolizas()
    }, [stDatos.ramosseguroID])

    // Mientras se genera el Excel solo se consulta el folio; antes se recargaba toda la pantalla cada 20 segundos
    useEffect(() => {
        if (reporteExcel !== 1) return;
        let intervalo = setInterval(() => { ftRevisarExcel(); }, 20000);
        return () => clearInterval(intervalo);
    }, [reporteExcel]);


    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
	    accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    }else{
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        {stEmpresasListas && <Tabla
            infoTabla={infoTabla}
            asyncData={Consultas.tablaPresupuestoAnual}
            token={token}
        />}
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={accionesFormulario}
            focus={refFocoFormulario}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);
}

export default PresupuestoAnual;
